import { LinearProgress } from '@material-ui/core'
import Switcher from 'components/Switcher'
import { ReactComponent as Img } from 'images/empty.svg'
import { ReactComponent as Logo } from 'images/logo.svg'
import React from 'react'
import styled from 'styled-components'
import { entityError, formError, getPublicForm, getVersion, submitForm } from 'utils/api'

const Form = styled.div`
    width: 50%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
	max-width: 500px;
`

const Container = styled.div`
	margin: 40px 0;
    display: flex;
    flex-direction: column;
	align-items: center;
`

const Text = styled.div`
    margin: 0 40px 40px;
	font-size: 30px;
	line-height: 45px;
	text-align: center;
`

const Caption = styled.div`
	color: #4a4a4a;
	text-transform: uppercase;
	letter-spacing: 2px;
	margin-bottom: 5px;
	font-size: 11px;
	text-align: center;
`

const Link = styled.a`
	display: block;
	text-decoration: none;
    margin-bottom: 10px;

	:hover {
		svg {
			transform: scale(1.05);
			transition: transform .3s cubic-bezier(.55,0,.1,1);
		}
	}
`

const Title = styled.div`
	font-size: 30px;
	margin-bottom: 30px;
`

const Info = styled.div`
    text-align: center;
    width: 100%;
    padding: 10px;
    color: #fff;
`

class Main extends React.Component {
    constructor(props) {
        super(props)

        this.form = null

        this.state = {
            loading: true,
            error: false,
			record: {},
			success: false
        }
    }

    componentDidMount() {
        const url = window.location.search
        getPublicForm(url)
        .then((result) => {
            this.form = result.form
            this.recipient = result.record

            const editableFields = this.form.fields.find(field => !field.autocomplete)

            if (editableFields) {
                this.setState({
                    loading: false,
                    record: result.record ? {...result.record} : {...result.base}
                })
            } else {
                this.setState({
                    record: result.record ? {...result.record} : {...result.base}
                }, () => this.submitForm())
            }
        },
        (error) => {
            console.log(error)
            this.setState({
                loading: false,
                error: error
            })
        })
    }

    handleChange = (field, value) => {
		const data = {...this.state.record}
		data[field] = value

		this.setState({
			record: {...data}
		})
    }

	handleSubmit = () => {
		this.setState({
			loading: true
		}, () => this.submitForm())
	}

	submitForm = () => {
		submitForm(this.form.id, this.state.record, this.recipient)
		.then(
			() => {
				this.setState({
					loading: false,
					success: true
				})
			},
			(error) => {
				console.log(error)
				this.setState({
					loading: false,
					error: error
				})
			}
		)
	}

    render() {
        return (
			<Container>
				{this.state.loading ?
					<div>
						<Link href='http://framelink.co/' target='_blank'>
							<Caption>Powered by</Caption>
							<Logo />
						</Link>
						<LinearProgress color="primary" />
					</div>
				: this.state.error ?
					<React.Fragment>
						<Text>
							{this.state.error === entityError || this.state.error === formError ?
								'This public form is no longer exist' :
								this.form && this.form.label.error ? this.form.label.error :
								'We are already working on solve the problem'
							}
						</Text>
						<Img />
					</React.Fragment>
				: this.state.success ?
					<React.Fragment>
						<Text>
							{this.form.label.success ? this.form.label.success : 'Thanks for your support!'}
						</Text>
						<Img />
						<div style={{marginTop: '40px'}}>
							<Link href='http://framelink.co/' target='_blank'>
								<Caption>Powered by</Caption>
								<Logo />
							</Link>
						</div>
					</React.Fragment>
					:
					<Form>
						{this.form.label.title &&
							<Title>
								{this.form.label.title}
							</Title>
						}
						<Switcher
							handleChange={this.handleChange}
							record={this.state.record}
							fields={this.form.fields}
							label={this.form.label}
							submitForm={this.handleSubmit}
						/>
					</Form>
				}
				<Info>{getVersion()}</Info>
            </Container>
        )
    }
}

export default Main
